import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit/typography';
import classNames from 'classnames';
import { CollapsedList } from '../CollapsedList';
import { Link } from '../Link';
import * as styles from './styles.css';

interface ILink {
  name: string;
  url: string;
}

interface ILinkListProps {
  links: ILink[];
  isOpened?: boolean;
  cols?: 1 | 2;
  onLinkClick(): void;
}

export function LinkList({ links, isOpened = true, cols = 1, onLinkClick }: ILinkListProps) {
  return (
    <CollapsedList isOpened={isOpened} visibleRows={2} cols={cols} containerStyles={styles['list']}>
      {links.map(({ name, url }, index) => (
        <Link
          key={`${name}_${index}`}
          target="blank"
          url={url}
          linkStyle={classNames(styles['link'], cols === 2 && styles['link--sec'])}
          onClick={onLinkClick}
        >
          <div className={styles['link-content']}>
            <InlineText1 color="primary_100">{name}</InlineText1>
          </div>
        </Link>
      ))}
    </CollapsedList>
  );
}
